import clsx from 'clsx';
import styles from './Loader.module.scss';
type Props = {
  center?: boolean;
  className?: string;
};
export const Loader = ({
  center,
  className
}: Props) => {
  return <span className={clsx(styles.loader, center && styles.center, className)} data-sentry-component="Loader" data-sentry-source-file="Loader.tsx"></span>;
};